/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import { UnassignButton } from "~/components/Tooling/UnassignButton";
import { Tool } from "~/models";
import { AssignmentRuleRouteParams } from "~/models/assignmentRule";
import {
  generateActionConfirmText,
  generateActionSuccessText,
  useAxios,
} from "~/tools";

type ARToolUnassignProps = {
  tool: Tool;
  serviceId: string;
  deleteCallback: () => void;
};

function ARToolUnassign({
  deleteCallback,
  serviceId,
  tool,
}: ARToolUnassignProps) {
  const {
    customerId,
    assignmentRuleId,
  } = useParams<AssignmentRuleRouteParams>();

  const [isOpen, setIsOpen] = React.useState(false);
  const { showError } = useShowError();

  const { Axios } = useAxios();

  return (
    <>
      <UnassignButton setIsOpen={setIsOpen} />
      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={async () => {
          try {
            await Axios().delete(
              `/customers/${customerId}/assignmentRules/${assignmentRuleId}/services/${serviceId}/tools/${tool.id}`
            );
            setIsOpen(true);
            deleteCallback();
            showSuccess(
              generateActionSuccessText(`The ${tool?.name} Tool`)()(
                "detached"
              )()
            );
          } catch (e) {
            showError(e.response);
          }
          setIsOpen(false);
        }}
        actionLabel="Unassign"
        contentLabel="Unassign Tool"
      >
        {generateActionConfirmText(`${tool?.name} Tool`)("unassign")()}
      </ModalConfirm>
    </>
  );
}

export { ARToolUnassign };
